define('ModuleLoader',[
    "jquery",
    "underscore",
    "logging",
    "utilities"
], function ($, _, logging, utilities) {
    var _ModuleName = "Module Loader";
    var _config = {
        attributes: {
            module: "ux-module",
            state: "ux-state",
            data: "ux-args"
        },
        states: {
            pending: "pending",
            loading: "loading",
            loaded: "loaded",
            error: "error"
        }
    }

    function loadPendingModules(scope, runAsync) {
        "use strict";
        
        // default runAsync to false
        runAsync = runAsync || false;

        ;

        // Deferred Object
        var deferred = $.Deferred();
        // Get Module Data
        var moduleElements = _getPendingModules(scope);
        var moduleNames = _.invoke(moduleElements, "getAttribute", "data-" + _config.attributes.module);

        // Make sure we actually have some modules to laod
        if(moduleNames.length == 0) {
            ;
            deferred.resolve();

            return deferred.promise();
        }

        var success = []; // Successfully loaded modules
        var failure = []; // Failed Modules

        // Load Modules using RequireJS
        require(moduleNames, function () {
            var modules = $.makeArray(arguments); // Get List of Modules Loaded

            ;
            // Loop through each module to initialize it
            for (var i = 0; i < modules.length; i++) {
                var module = modules[i];
                var $element = $(moduleElements[i]);
                var moduleName = moduleNames[i];
                var moduleObj = null;

                if(moduleName == "") continue;

                ;
                if (module.init) {
                    // If args passed in, deserialize
                    var args = $element.data(_config.attributes.data) || {};

                    // Make sure data was deserialized properly
                    if(typeof args == "string" && args.length > 0) {
                        try{
                            args = JSON.parse(args);
                        } catch(error) {
                            logging.error("Failed to parse module data for " + moduleName + ". Module will not be loaded.", _ModuleName);
                            logging.error("Module Data: " + args, _ModuleName);
                            logging.error("Error Message: " + error, _ModuleName);
                            return;
                        }
                    }

                    // Store scope on args
                    args.scope = $element;

                    // Catch any errors in the module to ensure it doesn't keep other modules from running
                    try {
                        if (runAsync) {
                            ;
                            _.defer(module.init, args);
                        } else {
                            ;
                            // Initialize Module
                            moduleObj = module.init(args);
                        }
                    } catch (error) {
                        error = moduleNames[i] + ": " + error;
                        failure.push(error);

                        // Log Error
                        logging.error(error, _ModuleName);

                        // Mark state as Error
                        utilities.setData($element, _config.attributes.state, _config.states.error);

                        continue;
                    }
                } else {
                    // Mark state as Error
                    utilities.setData($element, _config.attributes.state, _config.states.error);
                    continue;
                }

                // Mark state as loaded
                utilities.setData($element, _config.attributes.state, _config.states.loaded);
                // Remove data attribute
                $element.removeAttr('data-' + _config.attributes.data);
                success.push(moduleObj);
                ;
            }

            deferred.resolve(success);
        }, function (err) {
            for(var i = 0; i < err.requireModules.length; i++) {
                var module = err.requireModules[i];
                logging.error("Failed to load module : " + module, _ModuleName);
            }
        });

        return deferred.promise();
    }

    /**
     * Get module elements that are in the state requested
     * @param {*} scope 
     * @param {*} state 
     */
    function _getModulesByState(scope, state) {
        var selector = "*[data-" + _config.attributes.state + "='" + state + "']";
        return $(scope || "body").find(selector).addBack(selector);
    }

    /**
     * Get module elements that are in the pending state
     * @param {*} scope 
     */
    function _getPendingModules(scope) {
        return _getModulesByState(scope, _config.states.pending);
    }

    return {
        loadPendingModules: loadPendingModules
    }
});
